<template>
  <b-dropdown
    toggle-class="mono"
    split-class="mono"
    split-button-type="button"
    menu-class="multi-level-dropdown"
    :class="{ 'split-button': split == true }"
    :disabled="props.disabled"
    :dropright="props.level > 1"
    :split="props.split"
    :id="dropDownID"
    :text="props.buttonLabel"
    :offset="props.level > 1 ? -5 : 0"
    @click="itemClicked(null)"
    @show="onDropdownShow"
    @hide="onDropdownHide">
    <template #button-content v-if="props.level >= 1">
      <i v-safe-class="[props.icon]" v-if="props.icon !== undefined || props.modalName" v-b-modal="props.modalName" :disabled="props.disabled"></i>
      <span v-if="props.buttonLabel && !props.modalName">{{ $t(props.buttonLabel) }}{{ props.level > 1 ? "&nbsp;&nbsp;&nbsp;&nbsp;" : "" }}</span>
      <span v-if="props.buttonLabel && props.modalName" v-b-modal="props.modalName"
        >{{ $t(props.buttonLabel) }}{{ props.level > 1 ? "&nbsp;&nbsp;&nbsp;&nbsp;" : "" }}</span
      >
    </template>
    <template v-for="(item, index) in props.items">
      <b-dropdown-item v-if="!item.items" :key="index" :disabled="item.disabled" @click="itemClicked(item)" link-class="menu-option">
        <i :class="item.icon" v-if="item.icon !== undefined"></i>
        <span v-if="item.modalName" v-b-modal="item.modalName">
          {{ item.text == "automationServer.newAutomation" ? $t(item.text) + "..." : $t(item.text) }}
        </span>
        <span v-else>
          {{ item.text == "automationServer.newAutomation" ? $t(item.text) + "..." : $t(item.text) }}
        </span>
      </b-dropdown-item>
      <b-dropdown-item v-if="item.items" :key="index" link-class="menu-option">
        <multi-level-drop-down-button
          :split="false"
          :level="level + 1"
          :button-label="item.text"
          :icon="item.icon"
          :items="item.items"
          v-b-modal="item.modalName"
          @click="itemClicked"
          @show="onDropdownShow"
          @hide="onDropdownHide" />
      </b-dropdown-item>
    </template>
  </b-dropdown>
</template>
<script setup context lang="ts">
import { BvEvent } from "bootstrap-vue";
import { NavMenuItem } from "@medapro-types/common/common";
import { computed, reactive } from "vue";

//#region General
type Props = { split: boolean; level: number; buttonLabel?: string; icon?: string; items: Array<NavMenuItem>; modalName?: string; disabled?: boolean };
const props = defineProps<Props>();
const emit = defineEmits(["click", "show", "hide"]);
//#endregion

//#region ViewModel
type ViewModel = { isNestedDropdownVisible: boolean };
const viewModel = reactive<ViewModel>({ isNestedDropdownVisible: false });
//#endregion

//#region Computed Properties
const dropDownID = computed(() => "dropdown-level-" + props.level);
//#endregion

//#region Methods
const itemClicked = (item: NavMenuItem | null) => {
  emit("click", item);
};
const onDropdownShow = (bvEvent: BvEvent) => {
  emit("show", bvEvent);
  if (bvEvent.componentId !== "dropdown-level-1") {
    viewModel.isNestedDropdownVisible = true;
  }
};
const onDropdownHide = (bvEvent: BvEvent) => {
  emit("hide", bvEvent);
  if (bvEvent.componentId !== "dropdown-level-1") {
    viewModel.isNestedDropdownVisible = false;
  }
  if (viewModel.isNestedDropdownVisible) {
    bvEvent.preventDefault();
  }
};
//#endregion
</script>
